<template>
  <div class="error-overlay">
    <div class="center">
      <div class="icon" id="error"></div>
      <div class="message">
        <div class="label">
          <div class="global">Something went wrong!</div>
          <div class="error-message">{{this.$store.state.error}}</div>
          <div class="disclaimer"></div>
        </div>
      </div>
      <div class="icon" id="close" @click="dismissError"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorOverlay',
  created() {
      setTimeout(() => {
        this.$store.state.error = ''
      }, 4000)
  },
  methods: {
    dismissError() {
      this.$store.state.error = ''
    }
  }
}
</script>

<style scoped lang="stylus">

.error-overlay
  height: 100%
  left: 0
  position: absolute
  top: 0
  width: 100%
  z-index: 1000
  
  .center
    align-items: center
    border: 2px solid #ff8c8c
    justify-content: space-between
    padding: 15px
    display: flex
    flex-direction: row
    background-color: #ffdede
    border-radius: 5px
    box-shadow: 0 0 10px rgba($lynch, 0.25)
    left: 50%
    position: absolute
    top: 50%
    transform: translate(-50%, -50%)

    .icon
      background-position: center
      background-repeat: no-repeat
      background-size: contain
      flex-shrink: 0
        
    #error
      @extend .icon
      background-image: url("~@/assets/icons/close.png")
      height: 25px
      width: 25px

    #close
      @extend .icon
      background-image: url("~@/assets/icons/icon-cross.svg")
      height: 15px
      width: 15px
      cursor: pointer
      
    .label
      m-font-size(14, 18)
      margin: 0 20px
      font-family: $base-font-family
      color: black
      margin-top 5px
      align-items: space-around
      .global
        font-weight: bold
      .disclaimer
        m-font-size(12, 16)
        font-family: $base-font-family
        color $storm-gray
      .error-message
        color: black
        m-font-size(14, 18)

</style>